var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, forwardRef, NgModule, Input, Output, ChangeDetectorRef, ContentChildren, QueryList, Optional, HostBinding, EventEmitter, ChangeDetectionStrategy, NgZone, ViewChild, ElementRef } from '@angular/core';
import { LyRippleModule, LyRipple } from 'alyle-ui/ripple-minimal';
import { NG_VALUE_ACCESSOR, FormsModule, } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LyTheme, LyStyleTheme, ThemeModule, Platform, IsBoolean } from 'alyle-ui/core';
export var LY_RADIO_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return LyRadioGroup; }),
    multi: true
};
var idx = 0;
var LyRadioGroup = /** @class */ (function () {
    function LyRadioGroup(elementRef, theme, styleTheme, ngZone, cd) {
        this.elementRef = elementRef;
        this.theme = theme;
        this.styleTheme = styleTheme;
        this.ngZone = ngZone;
        this.cd = cd;
        this._value = null;
        this.name = "ly-radio-name-" + idx++;
        this._color = 'accent';
        this.value = null;
        this.radioColor = 'accent';
        this.changed = new Array();
        this.touched = new Array();
    }
    LyRadioGroup.prototype.touch = function () {
        this.touched.forEach(function (f) { return f(); });
    };
    LyRadioGroup.prototype.registerOnChange = function (fn) {
        this.changed.push(fn);
    };
    LyRadioGroup.prototype.registerOnTouched = function (fn) {
        this.touched.push(fn);
    };
    LyRadioGroup.prototype.writeValue = function (value) {
        this._value = value;
    };
    LyRadioGroup.prototype.ngAfterContentInit = function () {
    };
    LyRadioGroup.prototype.updatevalue = function (value) {
        this._value = value;
        this.changed.forEach(function (f) { return f(value); });
    };
    LyRadioGroup.prototype.markForCheck = function () {
        this.cd.markForCheck();
    };
    LyRadioGroup.prototype.ngAfterViewInit = function () {
        var _this = this;
        /**set value null if all checked === false */
        Promise.resolve(null).then(function () {
            var stateChecked = _this._radios.find(function (radio, index) { return radio.checked; });
            if (!stateChecked) {
                _this.updatevalue(null);
                _this.markForCheck();
            }
        });
    };
    LyRadioGroup.decorators = [
        { type: Component, args: [{
                    selector: 'ly-radio-group',
                    styles: ["\n    :host {\n      display: inline-flex;\n    }\n  "],
                    template: "<ng-content></ng-content>",
                    providers: [LY_RADIO_CONTROL_VALUE_ACCESSOR],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false
                },] },
    ];
    /** @nocollapse */
    LyRadioGroup.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: LyTheme, },
        { type: LyStyleTheme, },
        { type: NgZone, },
        { type: ChangeDetectorRef, },
    ]; };
    LyRadioGroup.propDecorators = {
        "value": [{ type: Input },],
        "radioColor": [{ type: Input, args: ['radioColor',] },],
        "_radios": [{ type: ContentChildren, args: [forwardRef(function () { return LyRadio; }),] },],
    };
    return LyRadioGroup;
}());
export { LyRadioGroup };
var LyRadio = /** @class */ (function () {
    function LyRadio(radioGroup, theme, changeDetectorRef, ngZone) {
        this.radioGroup = radioGroup;
        this.theme = theme;
        this.changeDetectorRef = changeDetectorRef;
        this.ngZone = ngZone;
        this.id = "ly-radio-id-" + idx++;
        this.name = '';
        this._value = null;
        this._checked = false;
        this.onCheckedState = new EventEmitter();
    }
    Object.defineProperty(LyRadio.prototype, "inputId", {
        get: function () {
            return this.id + "-input";
        },
        enumerable: true,
        configurable: true
    });
    LyRadio.prototype._onInputChange = function (event) {
        this.radioGroup.updatevalue(this.value);
    };
    LyRadio.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes['checked']) {
            if (this.checked) {
                Promise.resolve(null).then(function () {
                    _this.radioGroup.updatevalue(_this.value);
                });
            }
        }
    };
    LyRadio.prototype.ngOnInit = function () {
        if (this.radioGroup) {
            // Copy name from parent radio group
            this.name = this.radioGroup.name;
        }
    };
    LyRadio.prototype.ngAfterViewInit = function () {
        if (Platform.isBrowser) {
            this.ripple.lyRippleDisabled = true;
            this.ripple.rippleContainer.setTriggerElement(this._labelContainer.nativeElement);
            this.ripple.lyRippleDisabled = false;
        }
    };
    LyRadio.prototype._markForCheck = function () {
        this.changeDetectorRef.markForCheck();
    };
    LyRadio.decorators = [
        { type: Component, args: [{
                    selector: 'ly-radio',
                    styles: [":host { display: inline-block; } .ly-radio-input { pointer-events: none; opacity: 0; background: 0 0; position: absolute; width: 0; height: 0; } .ly-radio-label { cursor: pointer; white-space: nowrap; position: relative; display: inline-block; } .ly-radio-container { box-sizing: border-box; display: inline-block; position: relative; vertical-align: middle; height: calc(1em * 3); } .ly-radio-container .ly-radio-icon-container { width: 1.5em; height: 1.5em; } .ly-radio-input:checked ~ .ly-radio-container .ly-radio-inner-circle { transform: scale(0.6); } .ly-radio-input:checked ~ .ly-radio-container .ly-radio-outer-circle { border: solid 0.1em currentColor; color: currentColor !important; } .ly-radio-container .ly-radio-outer-circle, .ly-radio-container .ly-radio-inner-circle { transition: all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms; position: absolute; border-radius: 100%; box-sizing: border-box; width: 1.25em; height: 1.25em; top: 0; left: 0; right: 0; bottom: 0; margin: auto; } .ly-radio-container .ly-radio-outer-circle { border: solid 1px currentColor; } .ly-radio-container .ly-radio-inner-circle { background: currentColor; transform: scale(0); } .ly-radio-label-content { display: inline-block; padding: 0 0.5em; } "],
                    template: "\n  <label #_labelContainer [attr.for]=\"inputId\" class=\"ly-radio-label\">\n    <input\n      class=\"ly-radio-input\"\n      [class.ly-radio-checked]=\"checked\"\n      [id]=\"inputId\"\n      [checked]=\"checked\"\n      [name]=\"name\"\n      (change)=\"_onInputChange($event)\"\n      type=\"radio\"\n      >\n    <div #_ripple [color]=\"radioGroup.radioColor\" class=\"ly-radio-container\"\n      lyRipple\n      lyRippleCentered\n      yRippleSensitive\n      lyRippleRadius=\"containerSize\"\n    >\n      <div class=\"ly-radio-icon-container\">\n      <div class=\"ly-radio-outer-circle\" color=\"colorText\"></div>\n      <div class=\"ly-radio-inner-circle\"></div>\n      </div>\n    </div>\n    <div\n    class=\"ly-radio-label-content\"\n    color=\"colorText\">\n      <ng-content></ng-content>\n    </div>\n  </label>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false
                },] },
    ];
    /** @nocollapse */
    LyRadio.ctorParameters = function () { return [
        { type: LyRadioGroup, decorators: [{ type: Optional },] },
        { type: LyTheme, },
        { type: ChangeDetectorRef, },
        { type: NgZone, },
    ]; };
    LyRadio.propDecorators = {
        "ripple": [{ type: ViewChild, args: [LyRipple,] },],
        "_labelContainer": [{ type: ViewChild, args: ['_labelContainer',] },],
        "onCheckedState": [{ type: Output },],
        "checked": [{ type: HostBinding, args: ['class.ly-radio-checked',] }, { type: Input },],
        "value": [{ type: Input },],
    };
    __decorate([
        IsBoolean(),
        __metadata("design:type", Boolean)
    ], LyRadio.prototype, "checked", void 0);
    return LyRadio;
}());
export { LyRadio };
var LyRadioModule = /** @class */ (function () {
    function LyRadioModule() {
    }
    LyRadioModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, LyRippleModule, ThemeModule],
                    exports: [LyRadioGroup, LyRadio],
                    declarations: [LyRadioGroup, LyRadio],
                },] },
    ];
    /** @nocollapse */
    LyRadioModule.ctorParameters = function () { return []; };
    return LyRadioModule;
}());
export { LyRadioModule };
//# sourceMappingURL=radio.js.map